import React, { useState } from "react";
import Image from "../../../elements/Image";
import { Link } from "react-router-dom";
import { removeDuplicateFromArray } from "../../../../helpers";
import { getBlogList } from "../../../../services/BlogService";
import useFetch from "../../../../hooks/useFetch";
import dayjs from "dayjs";
import Noimage from "../../../../assets/images/no-image-available.png";
import { classNames } from "../../../../helpers/classNames";
import Quiltext from "../../../elements/Quiltext";

const FeaturedBlog = () => {
  const [query, setQuery] = useState({
    limit: 1,
    sortQuery: "-createdAt",
  });
  const {
    data: blogsData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-blogs-feature", query],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "blog",
        featured: true,
        ...query,
      });
      if (res?.docs?.status === 200) {
        const blogArr = (res?.docs?.data || [])
          ?.filter((item) => item?.title)
          ?.map((item) => ({
            ...item,
            _id: item?._id,
            date: dayjs(item?.publishDate)?.format("MMMM DD, YYYY"),
            image: item?.image?.url,
            link: `/blogs/${item?.slug || item?._id}`,
          }));

        return {
          ...res?.docs,
          data: removeDuplicateFromArray(blogArr)?.[0],
        };
      } else {
        if (blogsData?.data?.length > 0) {
          return blogsData;
        } else {
          return res;
        }
      }
    },
  });

  return (
    <>
      <Link to={blogsData?.data?.link} className="relative block space-y-8">
        <div className="w-full overflow-hidden aspect-[7/5] bg-shades-04">
          <Image
            src={blogsData?.data?.image || Noimage}
            alt={blogsData?.data?.title || "features-blog-image"}
            effect="blur"
            classes={classNames(
              !blogsData?.data?.image
                ? "scale-[0.7] object-contain"
                : "object-cover"
            )}
          />
        </div>
        <div className="flex items-center gap-10">
          {blogsData?.data?.postedBy && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-circle-user text-base xls:text-lg xl:text-xl"></i>{" "}
              By {blogsData?.data?.postedBy}
            </div>
          )}
          {blogsData?.data?.date && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-calendars text-base xls:text-lg xl:text-xl"></i>{" "}
              {blogsData?.data?.date}
            </div>
          )}
          {blogsData?.data?.time && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-clock text-base xls:text-lg xl:text-xl text-chestnut-rose"></i>{" "}
              {blogsData?.data?.time}
            </div>
          )}
        </div>
        <div className="space-y-8">
          {blogsData?.data?.title && (
            <h2 className="text-2xl lg:text-3xl font-bold mb-5 lg:mb-0">{blogsData?.data?.title}</h2>
          )}
          {blogsData?.data?.description && (
            <Quiltext description={blogsData?.data?.description} />
          )}
        </div>
      </Link>
    </>
  );
};

export default FeaturedBlog;
